import marked from 'marked'
import Turndown from 'turndown'
import sanitizeHtml from 'sanitize-html'

marked.setOptions({
  headerIds: false
})

function mdToHtml(mdText, { state, getters }, getContextionHref) {
  const contextedPrefix = state.contextedPrefix
  const renderer = new marked.Renderer()

  renderer.link = (href, title, text) => {
    const isContextedLink = href.startsWith(contextedPrefix)
    if (isContextedLink) {
      const re = new RegExp(`${contextedPrefix}([^]+)`)
      const match = re.exec(href)
      const contextedLinkOptions = match ? match[1].split(';') : []
      const noteId = contextedLinkOptions[0] || ''
      const { title: noteTitle } = noteId ? getters.getNoteById(noteId) || {} : ''
      const contextedHref = ''
      const contextedLink = `<a data-contexted-link="${noteId}" title="${noteTitle}"${contextedHref}>${text}</a>`
      return noteTitle ? contextedLink : text
    } else {
      return `<a target="_blank" href="${href}">${text}</a>`
    }
  }

  const sanitize = html => sanitizeHtml(html, {
    allowedTags: false,
    allowedAttributes: false
  })
  const html = mdText ? sanitize(marked(mdText, { renderer })) : ''
  const re = /(\[\[)(.*?)(\]\])/g
  const doc = new DOMParser().parseFromString(html, 'text/html')
  doc.querySelectorAll('p, b, u, i, li, h1, h2, h3').forEach(element => {
    // if (element.childElementCount === 0) {
    element.innerHTML = element.innerHTML.replace(re, (match, p1, p2, p3) => {
      // const { id: noteId } = getters.getNoteByTitle(p2) || {}
      return `${p1}<a data-contexted-link="true">${p2}</a>${p3}`
    })
    // }
  })
  return doc.body.innerHTML
}

function htmlToMd(htmlText, { state }) {
  const contextedPrefix = state.contextedPrefix
  const turndown = new Turndown({ headingStyle: 'atx' })
  const escapes = [
    [/\\/g, '\\\\'],
    [/\*/g, '\\*'],
    [/^-/g, '\\-'],
    [/^\+ /g, '\\+ '],
    [/^(=+)/g, '\\$1'],
    [/^(#{1,6}) /g, '\\$1 '],
    [/`/g, '\\`'],
    [/^~~~/g, '\\~~~'],
    // [/\[/g, '\\['],
    // [/\]/g, '\\]'],
    [/^>/g, '\\>'],
    [/_/g, '\\_'],
    [/^(\d+)\. /g, '$1\\. ']
  ]
  turndown.escape = string => escapes.reduce((accumulator, escape) => {
    return accumulator.replace(escape[0], escape[1])
  }, string)
  turndown.addRule('contextedLink', {
    filter(node) {
      return node.nodeName === 'A' && node.hasAttribute('data-contexted-link') && node.getAttribute('data-contexted-link') !== 'true'
    },
    replacement(content, node) {
      const href = node.getAttribute('data-contexted-link')
      return `[${content}](${contextedPrefix}${href})`
    }
  })
  const md = turndown.turndown(htmlText)
  return md
}

export {
  mdToHtml,
  htmlToMd
}
